"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fromMetadata;

var _v = _interopRequireDefault(require("./v0"));

var _v2 = _interopRequireDefault(require("./v4"));

// Copyright 2017-2019 @polkadot/storage authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

/**
 * Extend a storage object with the storage modules & module functions present
 * in the metadata.
 *
 * @param storage - A storage object to be extended.
 * @param metadata - The metadata to extend the storage object against.
 */
function fromMetadata(metadata) {
  // For v0-v3 we convert to v0, and use the fromV0 function to parse
  if ([0, 1, 2, 3].includes(metadata.version)) {
    return (0, _v.default)(metadata.asV0);
  } // For v4, we use fromV4 function


  return (0, _v2.default)(metadata.asV4);
}